import {
  Spinner,
  MessageBar,
  MessageBarType,
  Dialog,
  DialogFooter,
  DialogType,
  TextField,
  DefaultButton,
  PrimaryButton,
} from '@fluentui/react';
import {useEffect, useState} from 'react';
import commonStyles from '../../common/commonStyles.module.scss';
import {Subscription} from '../../Swagger/api';
import {getApis} from '../../webservices';

interface IChangeMaxUsers {
  onDone: () => void;
  onCancel: () => void;
  subscription: Subscription;
}

export const ChangeMaxUsers = (props: IChangeMaxUsers) => {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [maxUsers, setMaxUsers] = useState('');

  useEffect(() => {
    setMaxUsers((props.subscription.maxUsers || '').toString());
  }, [props.subscription.maxUsers]);

  const onChangeMaxUsers = async () => {
    setLoading(true);
    setHasError(false);

    try {
      const {subscriptionClient} = await getApis();
      await subscriptionClient.updateMaxUsers(
        props.subscription.id,
        Number(maxUsers)
      );
      props.onDone();
    } catch {
      setHasError(true);
      setLoading(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        subText:
          'Please set the new count of maximum users of the subscription:',
        title: 'Change max users',
        type: DialogType.normal,
      }}
      modalProps={{
        isBlocking: true,
      }}
      minWidth="40em"
      onDismiss={props.onCancel}
    >
      <TextField
        label="Max users"
        value={maxUsers}
        onChange={(_event, newValue) => setMaxUsers(newValue || '')}
      />
      <DialogFooter>
        <section className={commonStyles.dialogMessages}>
          {loading ? (
            <Spinner
              className={commonStyles.spinner}
              label="Please wait"
              ariaLive="assertive"
              labelPosition="right"
            />
          ) : null}
          {hasError ? (
            <MessageBar
              className={commonStyles.messageBar}
              messageBarType={MessageBarType.error}
              isMultiline={true}
              dismissButtonAriaLabel="Close"
            >
              Something went wrong. Please try again or contact an
              Administrator.
            </MessageBar>
          ) : null}
        </section>
        <PrimaryButton onClick={onChangeMaxUsers} text="Change max users" />
        <DefaultButton onClick={props.onCancel} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};
